module.exports = __webpack_public_path__ + "img/pic_10jifen2.fc437a15.png";